"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateLimit = exports.defaultRateLimitInitialText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var scenarios_1 = require("../../../../scenarios");
var shared_1 = require("../../../shared");
exports.defaultRateLimitInitialText = {
    sorry: "We\u2019re sorry",
    errorMessage: "Our site is currently experiencing heavy traffic.",
    message: "To ensure everyone has access to the site, we've temporarily disabled some of the features. \n      You can still use the site normally but without these features.",
    backSoon: "We will be fully back soon",
};
var RateLimit = function (_a) {
    var _b = _a.text, text = _b === void 0 ? exports.defaultRateLimitInitialText : _b, props = __rest(_a, ["text"]);
    var _c = props || {}, responseBody = _c.responseBody, _d = _c.headers, headers = _d === void 0 ? {} : _d;
    var _e = (0, scenarios_1.getResetTime)(responseBody, headers), resetTime = _e.resetTime, deltaSeconds = _e.deltaSeconds;
    return ((0, jsx_runtime_1.jsx)(shared_1.SharedError, __assign({ text: text }, { children: deltaSeconds
            ? "Please try again after ".concat(resetTime.toUTCString())
            : null })));
};
exports.RateLimit = RateLimit;
